import { ErrorHandler, Injectable, Injector, InjectionToken, Inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { LoggingService } from './logging.service';
import { ErrorService } from './error.service';
import { environment } from 'environments/environment';
import { AuthService } from '@bya/auth/services/authentication.service';
import { Subscription } from 'rxjs';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
	givenName: string;
	name: string;
	email: string;
	isAuthenticated: string;
	subscription: Subscription;

	constructor(private injector: Injector) { }


	handleError(error: Error | HttpErrorResponse) {

		const errorService = this.injector.get(ErrorService);
		const logger = this.injector.get(LoggingService);
		const auth = this.injector.get(AuthService);

		this.subscribeAuth(auth);

		let message;
		let stackTrace;

		if (error instanceof HttpErrorResponse) {
			// Server Error
			message = errorService.getServerMessage(error);
			stackTrace = errorService.getServerStack(error);
		} else {
			// Client Error
			message = errorService.getClientMessage(error);
			stackTrace = errorService.getClientStack(error);
		}

		// Always log errors
		logger.logError(message, stackTrace);

		console.error(error);

	}


	private subscribeAuth(auth: AuthService) {
        this.subscription = auth.authNavStatus$.subscribe(reportAuth => {
            this.isAuthenticated = reportAuth.status;
            if (reportAuth.user) {
                this.name = reportAuth.user.profile.name;
                this.givenName = reportAuth.user.profile.given_name;
                this.email = reportAuth.user.profile.email;
            }
        });
    }
}